export default __webpack_public_path__ + "static/media/destination1.94a04a44.jpg";